import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from "vue";
import d2Container from "./d2-container";

// 注意 有些组件使用异步加载会有影响
Vue.component("d2-container", d2Container);
Vue.component("d2-icon", function () {
  return import("./d2-icon");
});
Vue.component("d2-icon-svg", function () {
  return import("./d2-icon-svg/index.vue");
});
Vue.component("wlc-image", function () {
  return import("./wlc-image/index.vue");
});
Vue.component("wlc-upload-image", function () {
  return import("./wlc-upload/image.vue");
});
Vue.component("wlc-upload-file", function () {
  return import("./wlc-upload/file.vue");
});
Vue.component("wlc-upload-video", function () {
  return import("./wlc-upload/video.vue");
});
Vue.component("wlc-app-version", function () {
  return import("./wlc-app-version/index.vue");
});
Vue.component("wlc-remark", function () {
  return import("./wlc-remark/index.vue");
});
Vue.component("wlc-remark-list", function () {
  return import("./wlc-remark-list/index.vue");
});
Vue.component("wlc-auth-info", function () {
  return import("./wlc-auth-info/index.vue");
});
Vue.component("wlc-house-auth-info", function () {
  return import("./wlc-auth-info/house.vue");
});
Vue.component("wlc-house-auth-info-v2", function () {
  return import("./wlc-auth-info/houseV2.vue");
});
Vue.component("wlc-real-name-auth-info", function () {
  return import("./wlc-auth-info/realName.vue");
});
Vue.component("wlc-table-user", function () {
  return import("./wlc-table-user/index.vue");
});
Vue.component("wlc-table-user-list", function () {
  return import("./wlc-table-user-list/index.vue");
});
Vue.component("wlc-house-open-state", function () {
  return import("./wlc-house/openState.vue");
});
Vue.component("wlc-lifestyle-table-link", function () {
  return import("./wlc-lifestyle/table-link.vue");
});
Vue.component("wlc-community-table-link", function () {
  return import("./wlc-community/table-link.vue");
});
Vue.component("wlc-used-table-link", function () {
  return import("./wlc-used/table-link.vue");
});
Vue.component("wlc-article-table-link", function () {
  return import("./wlc-article/table-link.vue");
});
Vue.component("wlc-house-table-number", function () {
  return import("./wlc-house/table-number.vue");
});
Vue.component("wlc-image-info", function () {
  return import("./wlc-image/info.vue");
});
Vue.component("wlc-image-rotate", function () {
  return import("./wlc-image/rotate.vue");
});
Vue.component("wlc-video", function () {
  return import("./wlc-video/index.vue");
});
Vue.component("wlc-rich-text", function () {
  return import("./wlc-rich-text/index.vue");
});
Vue.component("wlc-im-count", function () {
  return import("./wlc-im-count/index.vue");
});
Vue.component("wlc-house-table-address", function () {
  return import("./wlc-house/table-address.vue");
});
Vue.component("wlc-user-table-tag", function () {
  return import("./wlc-user/table-tag.vue");
});
Vue.component("wlc-breadcrumb", function () {
  return import("./wlc-breadcrumb/index.vue");
});
Vue.component("wlc-set-user-type", function () {
  return import("./wlc-user/set-type.vue");
});
Vue.component("wlc-set-house-type", function () {
  return import("./wlc-house/set-type.vue");
});
Vue.component("wlc-house-top-button", function () {
  return import("./wlc-house/top-button.vue");
});
Vue.component("wlc-house-pass-button", function () {
  return import("./wlc-house/pass-button.vue");
});
Vue.component("wlc-house-reject-button", function () {
  return import("./wlc-house/reject-button.vue");
});
Vue.component("wlc-house-delete-button", function () {
  return import("./wlc-house/delete-button.vue");
});
Vue.component("wlc-miniprogram-qrcode", function () {
  return import("./wlc-miniprogram-qrcode/index.vue");
});
Vue.component("wlc-radar-chart", function () {
  return import("./wlc-radar-chart/index.vue");
});
Vue.component("wlc-quarter-radar-chart", function () {
  return import("./wlc-quarter-radar-chart/index.vue");
});
Vue.component("wlc-quarter-radar-pop", function () {
  return import("./wlc-quarter-radar-pop/index.vue");
});
Vue.component("wlc-pop-radar-chart", function () {
  return import("./wlc-pop-radar-chart/index.vue");
});
Vue.component("wlc-user-type", function () {
  return import("./wlc-user-type/index.vue");
});
Vue.component("wlc-user-pop", function () {
  return import("./wlc-user-pop/index.vue");
});
Vue.component("wlc-user-list-pop", function () {
  return import("./wlc-user-list-pop/index.vue");
});
Vue.component("wlc-user-card", function () {
  return import("./wlc-user-card/index.vue");
});
Vue.component("wlc-at-mention-input", function () {
  return import("./wlc-at-mention-input/index.vue");
});